const oidc = {
    logout_success: '你已經成功登出。',
};
export default oidc;
